import {createStyles, Theme} from "@material-ui/core";
import {buttonContainedLarge, greyInput} from "src/main.style";

export const GiphyStyles = (theme: Theme) =>
  createStyles({
    dialogTop: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "relative",
    },
    container: {
      padding: theme.spacing(2.5),
    },
    searchContainer: {
      display: "flex",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
      alignItems: "center",
    },
    greyInput: {
      ...greyInput, // Återanvänder samma input-stil som i ExternalCalendarEdit
      flex: 1, // Gör att input-fältet tar upp det mesta av bredden
    },
    searchButton: {
      ...buttonContainedLarge,
    },
    gifContainer: {
      display: "flex",
      width: "calc(50% - 5px)",
      flexDirection: "column",
      flexWrap: "wrap",
      gap:'10px',
    },
    gifCard: {
      width: "100%",
      cursor: "pointer",
      borderRadius: theme.shape.borderRadius,
      overflow: "hidden",
      height: 'fit-content',
    },
    gifMedia: {
      width: "100%",
      height: "auto",
      objectFit: "cover",
    },
  });



// WEBPACK FOOTER //
// ./src/components/chat/giphy/Giphy.style.ts